import DOMHelper from "../../lib/dom-helper";
import {EasingFunctions} from "../../lib/animation-module";
import SmoothScroll from 'smooth-scroll/dist/smooth-scroll.min.js';
import {throttle} from "../../lib";

export default class AnchorNav {
    constructor() {
        this.$root = document.getElementById('headerAnchorNav');
        this.$container = null;
        this.$links = null;
        this.$sections = null;
        this.$activeLink = null;

        this.smoothScroll = new SmoothScroll();
        this.sectionPositions = {};

        this.init();
    }

    get scrollPosTopMargin() {
        const media = window.matchMedia('(max-width: 768px)').matches;
        return media ? 89 : 81;
    }

    init() {
        if (!this.$root) {
            return;
        }

        this.$container = this.$root.querySelector('.header-anchor-nav-container');
        this.$links = this.$root.querySelectorAll('.header-anchor-nav-link');
        this.$sections = document.querySelectorAll('[data-anchor]');

        if (!this.$links.length) {
            return;
        }

        this.$links.forEach(($link) => {
            $link.addEventListener('click', (e) => {
                e.preventDefault();
                this.scrollToSection($link.dataset.id);
            });
        });

        window.addEventListener('scroll', throttle(() => {
            this.collectSectionPositions();

            const scrollPos = window.scrollY;

            for (const id of Object.keys(this.sectionPositions)) {
                if (scrollPos > this.sectionPositions[id].top && scrollPos < this.sectionPositions[id].bottom) {
                    this.setActiveLink(id);
                }
            }

        }, 20));
    }

    collectSectionPositions() {
        // Collect all section Y positions (minus top margin)
        this.$sections.forEach(($section, i) => {
            let sectionYPos = DOMHelper.getElementTopPosition($section) - this.scrollPosTopMargin - 5;
            this.sectionPositions[$section.dataset.anchor] = {
                top: sectionYPos,
                bottom: sectionYPos + $section.offsetHeight / 2
            };
        });
    }

    scrollToSection(id) {
        const $section = document.querySelector(`[data-anchor="${id}"]`);

        if (!$section) {
            return;
        }

        let scrollToPos = DOMHelper.getElementTopPosition($section);
        scrollToPos -= this.scrollPosTopMargin;

        // Prevent bug when scrolling gets stuck on repeating scroll trigger
        // if window is on section's position
        // but window scrollY pos value is float number
        if (scrollToPos === Math.floor(window.scrollY) || scrollToPos === Math.ceil(window.scrollY)) {
            return;
        }

        this.smoothScroll.animateScroll(scrollToPos, null, {
            speed: 360,
            customEasing: EasingFunctions.primary
        });
    }

    setActiveLink(id) {
        if (this.$activeLink && this.$activeLink.dataset.id === id) {
            return;
        }

        if (this.$activeLink) {
            this.$activeLink.classList.remove('-active');
        }

        this.$activeLink = Array.from(this.$links).find(($link) => $link.dataset.id === id);
        this.$activeLink.classList.add('-active');
    }

    // scrollListToActiveLink($link) {
    //     $container.scrollTo(0, y);
    // }
}